var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audit-list"},_vm._l((_vm.audit),function(item){return _c('CockpitMatryoshkaItemAuditListItem',{key:item.status,staticClass:"audit-list-item",attrs:{"user":item.user,"action":item.action,"date":item.date}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }